import React, { useState, useEffect, useRef } from "react";
import Message from "./Message";
import SendMessage from "./SendMessage";
import { db } from "../../../api/firebase";
import { query, collection, orderBy, onSnapshot } from "firebase/firestore";

const styles = {
  main: {
    // display: "flex",
    // flexDirection: "column",
    // height:'500px',
    padding: "10px",
  },
};

const Chat = (rowData) => {
  const [messages, setMessages] = useState([]);
  // const scroll = useRef();
console.log(rowData)
  useEffect(() => {
    // const q = query(collection(db, "task",), orderBy("timestamp"));
    const q = query(collection(db, "tasks",rowData.rowData?.id, "messages"), orderBy("orderTime"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      let messages = [];
      querySnapshot.forEach((doc) => {
        messages.push({ ...doc.data(), id: doc.id });
      });
      setMessages(messages);
    });
    return () => unsubscribe();
  }, [rowData]);
console.log(messages)
  return (
    <>
      <main style={styles.main}>
        {messages &&
          messages.map((message) => (
            <Message key={message.id} message={message} rowData={rowData}/>
          ))}
      </main>
      <SendMessage rowData={rowData}/>
    </>
  );
};

export default Chat;
